var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-edit" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "Widget",
        { attrs: { title: (_vm.isNew ? "New" : "Edit") + " award" } },
        [
          !_vm.isNew && _vm.isReceiving
            ? _c("Loader", { attrs: { size: 40 } })
            : _c(
                "Form",
                [
                  _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "label",
                      { staticClass: "col-md-2", attrs: { for: "name" } },
                      [_vm._v("Award title")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-5" }, [
                      _c("input", {
                        staticClass: "form-control",
                        attrs: { id: "name", type: "text" },
                        domProps: { value: _vm.award.title },
                        on: {
                          change: function($event) {
                            return _vm.updateAwardProperty($event, "title")
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "label",
                      {
                        staticClass: "col-md-2",
                        attrs: { for: "description" }
                      },
                      [_vm._v("Award description")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-5" }, [
                      _c("textarea", {
                        staticClass: "form-control",
                        attrs: { id: "description", type: "text" },
                        domProps: { value: _vm.award.description },
                        on: {
                          change: function($event) {
                            return _vm.updateAwardProperty(
                              $event,
                              "description"
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.awardActionsAndThresholds, function(
                    awardAction,
                    i
                  ) {
                    return _c("div", [
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-md-2",
                            attrs: { for: "threshold" }
                          },
                          [
                            _vm._v(
                              "\n                            Threshold " +
                                _vm._s(i + 1) +
                                "\n                            "
                            ),
                            _vm.awardActionsAndThresholds.length > 1
                              ? _c("i", {
                                  staticClass: "fa fa-close ml-4",
                                  on: {
                                    click: function($event) {
                                      return _vm.removeAwardAction(i)
                                    }
                                  }
                                })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-5" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: awardAction.threshold,
                                expression: "awardAction.threshold"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { id: "threshold", type: "number" },
                            domProps: { value: awardAction.threshold },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  awardAction,
                                  "threshold",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-group row" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "col-md-2",
                              attrs: { for: "awardAction" }
                            },
                            [_vm._v("Action " + _vm._s(i + 1))]
                          ),
                          _vm._v(" "),
                          _c("v-select", {
                            staticClass: "col-md-5",
                            attrs: {
                              clearable: false,
                              required: "",
                              id: "awardAction",
                              options: _vm.awardActions
                            },
                            model: {
                              value: awardAction.action,
                              callback: function($$v) {
                                _vm.$set(awardAction, "action", $$v)
                              },
                              expression: "awardAction.action"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  }),
                  _vm._v(" "),
                  _vm.awardActionsAndThresholds.length < _vm.awardActions.length
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mb-3 mb-xs mr-xs",
                          attrs: { variant: "outline-info" },
                          on: { click: _vm.addNewAwardAction }
                        },
                        [
                          _vm._v(
                            "\n                    Add new action\n                "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group row" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "col-md-2",
                          attrs: { for: "recurrenceUM" }
                        },
                        [_vm._v("Recurrence")]
                      ),
                      _vm._v(" "),
                      _c("v-select", {
                        staticClass: "col-md-5",
                        attrs: {
                          clearable: false,
                          required: "",
                          id: "recurrenceUM",
                          options: _vm.awardRecurrence
                        },
                        model: {
                          value: _vm.award.recurrence,
                          callback: function($$v) {
                            _vm.$set(_vm.award, "recurrence", $$v)
                          },
                          expression: "award.recurrence"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c("label", { staticClass: "col-md-2" }, [
                      _vm._v("Award image")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-5" },
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-modal",
                                rawName: "v-b-modal.add-award-icon-modal",
                                modifiers: { "add-award-icon-modal": true }
                              }
                            ],
                            staticClass: "mb-3 mb-xs mr-xs",
                            attrs: { variant: "outline-info" }
                          },
                          [
                            _vm._v(
                              "\n                            Choose icon\n                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("img", {
                            staticStyle: { "max-width": "100px" },
                            attrs: { src: _vm.pickedAwardIcon }
                          })
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "abc-checkbox abc-checkbox-primary mb-4" },
                    [
                      _c("input", {
                        attrs: { type: "checkbox", id: "isPublic" },
                        domProps: { checked: _vm.award.public == true },
                        on: {
                          change: function($event) {
                            return _vm.togglePublic()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "isPublic" } }, [
                        _vm._v("Active")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showGlobalOption()
                    ? _c(
                        "div",
                        {
                          staticClass: "abc-checkbox abc-checkbox-primary mb-4"
                        },
                        [
                          _c("input", {
                            attrs: { type: "checkbox", id: "isGlobal" },
                            domProps: { checked: _vm.award.global == true },
                            on: {
                              change: function($event) {
                                return _vm.toggleGlobal()
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "isGlobal" } }, [
                            _vm._v("Global")
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.errorsList, function(error) {
                    return _c(
                      "b-alert",
                      {
                        key: error,
                        staticClass: "alert-sm w-25",
                        attrs: {
                          variant: "danger",
                          show: _vm.errorsList.length > 0
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(error) +
                            "\n                "
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "b-button-toolbar",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "success" },
                          on: {
                            click: function($event) {
                              return _vm.saveAward()
                            }
                          }
                        },
                        [
                          _vm.isUpdating
                            ? _c("Loader")
                            : _c("span", [_vm._v("Save")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "default" },
                          on: {
                            click: function($event) {
                              return _vm.goBack()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        Back\n                    "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                2
              )
        ],
        1
      ),
      _vm._v(" "),
      _c("AddAwardIcon")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "page-title" }, [
      _vm._v(
        "Award                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    - "
      ),
      _c("span", { staticClass: "fw-semi-bold" }, [_vm._v("Detail")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }